import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServicePathProviderService } from '@blk/cwp-ng-framework';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppConfigApiService {

	private static readonly API_GATEWAY: string = 'api-gateway';
	private static readonly APP_CONFIG: string = '/advisor-center/config/get-display';

	constructor(private servicePathProvider: ServicePathProviderService, private http: HttpClient) { }

	private getApiGatewayPath(path: string): string {
		return this.servicePathProvider.getServicePath(AppConfigApiService.API_GATEWAY) + path;
	}

	public fetchAppConfigData(): Observable<any> {
		const url = this.getApiGatewayPath(AppConfigApiService.APP_CONFIG);
		return this.http.get(url);
	}
}
